<template>
<v-container app :fluid="true" class="pt-0">    
    <v-row>
        <v-col cols="6">
            <v-card>
                <SalesChart></SalesChart>
            </v-card>            
        </v-col>
        <v-col cols="6">
            <v-card>
                <ProductsChart></ProductsChart>
            </v-card>            
        </v-col>
    </v-row>
</v-container>
</template>

<script>
import SalesChart from '../../components/Dashboard/SalesChart'
import ProductsChart from '../../components/Dashboard/ProductsChart'

export default {
    name: 'Dashboard',
    components: {
        SalesChart,
        ProductsChart
    }
}
</script>

<style scoped>

</style>